var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.92532 0.666748L7.81066 1.24902L7.372 3.37964C6.67067 3.64746 6.03466 4.02725 5.45999 4.47762L3.31599 3.76074L2.74 3.58219L2.44133 4.09652L0.965322 6.56421L0.666656 7.07861L1.10399 7.46102L2.76266 8.87207C2.70266 9.24116 2.62534 9.60623 2.62534 9.99398C2.62534 10.3817 2.70266 10.7469 2.76266 11.116L1.10399 12.527L0.666656 12.9094L0.965322 13.4237L2.44133 15.8915L2.74 16.4071L3.31599 16.2273L5.45999 15.5104C6.03466 15.9608 6.67067 16.3405 7.372 16.6083L7.81066 18.7389L7.92532 19.3213H12.0733L12.1893 18.7389L12.6267 16.6083C13.328 16.3405 13.964 15.9608 14.5387 15.5104L16.6827 16.2273L17.2587 16.4071L17.5587 15.8915L19.0333 13.4237L19.3333 12.9094L18.8947 12.527L17.236 11.116C17.2973 10.7469 17.3733 10.3817 17.3733 9.99398C17.3733 9.60623 17.2973 9.24116 17.236 8.87207L18.8947 7.46102L19.3333 7.07861L19.0333 6.56421L17.5587 4.09652L17.2587 3.58219L16.6827 3.76074L14.5387 4.47762C13.964 4.02725 13.328 3.64746 12.6267 3.37964L12.1893 1.24902L12.0733 0.666748H7.92532Z",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6662 9.99398C12.6662 11.465 11.4715 12.6589 9.9995 12.6589C8.5275 12.6589 7.33283 11.465 7.33283 9.99398C7.33283 8.52294 8.5275 7.3291 9.9995 7.3291C11.4715 7.3291 12.6662 8.52294 12.6662 9.99398Z",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCog);
export default __webpack_public_path__ + "static/media/ic_cog.65ff5edcdb9260d26650f0e3055fed34.svg";
export { ForwardRef as ReactComponent };